import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useGalleryPhotos } from "@/hooks/useGalleryPhotos";
import AdminUploader from "@/components/admin/AdminUploader";
import AdminPhotoGrid from "@/components/admin/AdminPhotoGrid";
import { API } from "@/lib/api";

export default function AdminGallery() {
  const { pin } = useAdminAuth();
  const { photos, refresh } = useGalleryPhotos();

  const handleDelete = async (id) => {
    if (!window.confirm("Remover esta foto da galeria pública?")) return;
    try {
      await axios.delete(`${API}/gallery/${id}?pin=${encodeURIComponent(pin)}`);
      toast.success("Foto removida");
      refresh();
    } catch {
      toast.error("Falha ao remover");
    }
  };

  return (
    <div className="p-6 lg:p-10">
      <section className="grid lg:grid-cols-12 gap-8">
        <AdminUploader pin={pin} onUploaded={refresh} />
        <AdminPhotoGrid photos={photos} onDelete={handleDelete} />
      </section>
    </div>
  );
}
